var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twotone-3d_rotation-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3623",
    "data-name": "Caminho 3623",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3624",
    "data-name": "Caminho 3624",
    d: "M11.92,8.28A4.5,4.5,0,0,0,7.24,3l3.09,3.09L6.09,10.33,3,7.24a4.472,4.472,0,0,0,5.14,4.69,4.437,4.437,0,0,0,2-.82l9.46,9.46.88-.88-9.45-9.45a4.356,4.356,0,0,0,.89-1.96Z",
    fill: "rgba(46,128,195,0.3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3625",
    "data-name": "Caminho 3625",
    d: "M22.61,18.97,13.54,9.9A6.5,6.5,0,0,0,3.67,2.25L7.5,6.08,6.08,7.5,2.25,3.67a6.491,6.491,0,0,0,7.54,9.9l9.11,9.11a1,1,0,0,0,1.41,0l2.3-2.3a.978.978,0,0,0,0-1.41Zm-3,1.6-9.46-9.46a4.372,4.372,0,0,1-2,.82A4.486,4.486,0,0,1,3,7.24l3.09,3.09,4.24-4.24L7.24,3a4.486,4.486,0,0,1,4.68,5.27,4.362,4.362,0,0,1-.88,1.95l9.45,9.45Z",
    fill: "#2e80c3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolIcon);
export default __webpack_public_path__ + "static/media/tool-icon.87d96cf4cd92dd6b2e847d31893bcf01.svg";
export { ForwardRef as ReactComponent };